import React from 'react'
import { getImgSrc } from '../../../services/common/CommonUtils'
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper';

const CurrentPackData = ({ isPostpaid = true }) => {
  if(isPostpaid){
    return <PostpaidData />
  }else{
    return <PrepaidData />
  }
}

const PostpaidData = () => {
    return (
        <div class="white_card dashboard_card sprint14-blance-info2 mt-30">
        <div>
            <div class="balance_section_info">
                <div className='d-flex'>
                <label className='me-3 shimmerBG shimmer-text-xs w-30'></label>
                <label className='shimmerBG shimmer-text-xs w-20'></label>
                </div>
                
                <h5 className='shimmerBG shimmer-text-sm w-50 mt-2'>  </h5>
                <div class="sprint14-pack-active mt-3">
                    <label className='shimmerBG shimmer-text-xs w-30'> </label>
                </div>
                <hr />
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label className='shimmerBG shimmer-text-xs w-80'></label>
                        <div> : </div>
                    </div>
                    <div className='shimmerBG shimmer-text-xs w-40'></div>
                </div>
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label className='shimmerBG shimmer-text-xs w-80'></label>
                        <div> : </div>
                    </div>
                    <div className='shimmerBG shimmer-text-xs w-40'></div>
                </div>
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label className='shimmerBG shimmer-text-xs w-80'></label>
                        <div> : </div>
                    </div>
                    <div className='shimmerBG shimmer-text-xs w-40'></div>
                </div>
                <div class="d-flex align-items-center sprint14-blance-row mt-2">
                    <div class="sprint14-blance-col d-flex align-items-center justify-content-between">
                        <label className='shimmerBG shimmer-text-xs w-80'></label>
                        <div> : </div>
                    </div>
                    <div className='shimmerBG shimmer-text-xs w-40'></div>
                </div>
            </div>
             {/* <hr />  // view call history text addition */}
            <div class="d-flex justify-content-between align-item-center">

                <div class="balance_section_action align-self-center">
                    {/* <button class="custom_btn custom_btn_sm custom_btn_primary">Upgrade Plan</button> */}
                </div>

                <div className='w-100'>
                    <div class="hyperlink" href='#' className='shimmerBG shimmer-text-xs w-20 ms-auto'>
                        {/* <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow" /> */}
                    </div>
                </div>

            </div>
        </div>
        
            <hr/> 
            <div class="sp17-viewdetails-button gap-10 shimmerBG shimmer-text-sm w-40">
                <a>
                    {/* <img src={ process.env.PUBLIC_URL + "/assets/images/sprint17/call-details.svg"}/> View call history  */}
                    {/* <img src={ process.env.PUBLIC_URL + "/assets/images/sprint16/right-arrow-red.svg"}/>  */}
                </a>
            </div>
      
    </div>
    )
}

const PrepaidData = () => {
    return (
        <div class="white_card dashboard_card mt-30">
            <div class="flex_grp_between">
                <div class="tabs-comp-two">
                    <section class="corp-abt-thumb-slider pack-tab-swiper-two sprint14-pack-tabs">
                        <div class="position-relative category-tabs">
                            <div class="container-tab position-relative">
                                <Swiper
                                    className="swiper-container tabs-thumbs c-about-thumbs gap-4"
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    onSwiper={() => {}}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    spaceBetween={0}
                                    slidesPerView={3}
                                    observer={true}
                                    observeParents={true}
                                >
                                    <SwiperSlide className='w-50'>
                                        <p class="year-cont">
                                            <div className='shimmerBG shimmer-text-sm w-60 mx-auto'></div>
                                        </p>
                                    </SwiperSlide>
                                        <SwiperSlide className='w-50'>
                                            <p class="year-cont">
                                                <div className='shimmerBG shimmer-text-sm w-60 mx-auto'></div>
                                            </p>
                                        </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>

                        <Swiper
                            className="swiper-container tabs-top-swiper container p-0"
                            modules={[FreeMode, Navigation, Thumbs]}
                            thumbs={{ swiper: null }}
                            observer={true}
                            observeParents={true}
                            spaceBetween={10}
                            navigation={{
                                nextEl: '.swipertabs-button-next',
                                prevEl: '.swipertabs-button-prev',
                            }}
                        >
                            <SwiperSlide>
                                <section class="">
                                    <div class="align-items-center justify-content-between sprint14-currentpack-tab" >
                                        <div class="d-flex align-items-center justify-content-between" >
                                            <div class="current-pack-lr" > <h4 className='shimmerBG shimmer-text-sm w-60'> </h4> </div>
                                            <div class="current-pack-rl view-more-btn pointer">
                                                 {/* {currentPackData?.btntext} 
                                                 <img src={getImgSrc('/assets/images/right_arrow_red.svg')}
                                                 alt="arrow" class="right-arrow" />  */}

                                                 {/* before */}
                                                 {/* <a class="hyperlink" href="#">{currentPackData?.btntext} 
                                                 <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow"></img></a> */}

                                                 {/* sprint 16 */}
                                                 <a class="hyperlink" href="#" className='shimmerBG shimmer-text-xs w-30'> 
                                                   {/* <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow"></img> */}
                                                   </a>
                                                 </div>
                                        </div>
                                        <div class="pack-active-row mt-2">
                                            <label className='shimmerBG shimmer-text-xs w-50'></label>
                                                <></>
                                            <div class="d-flex align-items-center">
                                                        {/* <img src={'icon'} alt="timer-icon" /> */}
                                                <span> </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </SwiperSlide>

                            <SwiperSlide><></></SwiperSlide>
                        </Swiper>

                      {/* view call history */}
                      <hr/> 
                        <div class="sp17-viewdetails-button gap-10">
                            <div className='shimmerBG shimmer-text-sm w-40 mb-0'>

                            </div>
                            {/* <a>
                                <img src={process.env.PUBLIC_URL + "/assets/images/sprint17/call-details.svg"}/> View call history 
                                <img src={process.env.PUBLIC_URL + "/assets/images/sprint16/right-arrow-red.svg"}/> 
                            </a> */}
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default CurrentPackData